import styled from 'styled-components';
import { devices } from '../../../styles/viewports';
import zIndexes from '../../../styles/zIndexes';
import { Grid } from '../../atoms';

export const InnerModal = styled.div`
  padding: 62px;
  background-color: var(--base-color-white);
  z-index: ${zIndexes.popup};
  position: relative;

  @media ${devices.smallMobile}, ${devices.mobile} {
    height: 100vh;
    padding: 62px 0 0;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px;
  height: 26px;
  width: 26px;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  @media ${devices.tablet} {
    margin: 25px;
  }
  @media ${devices.desktop}, ${devices.largeDesktop} {
    margin: 30px;
  }
`;

export const ContentWrapper = styled.div``;

export const Overlay = styled(Grid)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-content: center;
  background-color: rgba(0, 0, 0, 0.4);
`;
